import { useState } from "react"
import { Link } from "react-router-dom"

const Hero = () => {
  return (
    <section className="bg-white py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
        {/*   <div className="space-y-8">
        
            <div className="space-y-6">
              <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 leading-tight">
                Discover the Art of Custom Resin Creations
              </h1>
              <p className="text-lg text-gray-600 leading-relaxed max-w-lg">
                At RangDesaaj, we bring your resin dreams to life with vibrant, customizable designs. Explore our unique
                pieces and let your creativity shine!
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
         <Link to="/shop" className="text-xl font-bold text-gray-900 italic">
              <button className="bg-black text-white px-8 py-3 font-medium hover:bg-gray-800 transition-colors">
                Shop
              </button>
              </Link>
            </div>
          </div> */}
          
          <div className="flex flex-col justify-center items-center bg-white px-4">
  <div className="space-y-8 text-center">
    <div className="space-y-6">
      <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 leading-tight">
        Discover the Art of Custom Resin Creations
      </h1>
      <p className="text-lg text-gray-600 leading-relaxed max-w-lg mx-auto">
        At RangDesaaj, we bring your resin dreams to life with vibrant, customizable designs. Explore our unique
        pieces and let your creativity shine!
      </p>
    </div>

    {/* CTA Buttons */}
    <div className="flex flex-col sm:flex-row gap-4 justify-center">
      <Link to="/shop" className="text-xl font-bold text-gray-900 italic">
        <button className="bg-black text-white px-8 py-3 font-medium hover:bg-gray-800 transition-colors">
          Shop
        </button>
      </Link>
    </div>
  </div>
</div>


          {/* Right Image */}
      {/* <div className="relative">
            <div className="bg-gray-200 rounded-lg aspect-square lg:aspect-[4/3] flex items-center justify-center">
              <div className="bg-gray-300 rounded-lg w-24 h-24 flex items-center justify-center">
                <svg className="w-12 h-12 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  )
}

export default Hero
